import { createTheme } from "@mui/material/styles";

const white = "#FFFFFF";
const lightGreen = "#0FDB94";
const darkPurple = "#321554";
const red = "#AC2124";
const lightGrey = "#EDECEA";

const mainFontStack = "\"Cera-Pro\", 'Helvetica Neue', Arial, Helvetica, sans-serif";

export const theme = createTheme({
    palette: {
        primary: {
            main: lightGreen,
        },
        secondary: {
            main: darkPurple,
            contrastText: white,
        },
        error: {
            main: red,
        },
        grey: {
            50: lightGrey,
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 750,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
    typography: {
        fontFamily: mainFontStack,
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: `
                @font-face  {
                    font-family: 'Cera-Pro';
                    src:url('../../../fonts/Cera-Pro-Thin.eot'); 
                    src:url('../../../fonts/Cera-Pro-Thin.eot?#') format('eot'),    
                          url('../../../fonts/Cera-Pro-Thin.woff') format('woff');
                          font-weight: 200;
                          font-style: normal;
                }
                @font-face  {
                    font-family: 'Cera-Pro';
                    src:url('../../../fonts/Cera-Pro-Light.eot'); 
                    src:url('../../../fonts/Cera-Pro-Light.eot?#') format('eot'),    
                          url('../../../fonts/Cera-Pro-Light.woff') format('woff');
                          font-weight: 300;
                          font-style: normal;
                }
                @font-face  {
                    font-family: 'Cera-Pro';
                    src:url('../../../fonts/Cera-Pro-Regular.eot'); 
                    src:url('../../../fonts/Cera-Pro-Regular.eot?#') format('eot'),    
                          url('../../../fonts/Cera-Pro-Regular.woff') format('woff');
                          font-weight: 400;
                          font-style: normal;
                }
                @font-face  {
                    font-family: 'Cera-Pro';
                    src:url('../../../fonts/Cera-Pro-Medium.eot'); 
                    src:url('../../../fonts/Cera-Pro-Medium.eot?#') format('eot'),    
                          url('../../../fonts/Cera-Pro-Medium.woff') format('woff');
                          font-weight: 500;
                          font-style: normal;
                }
                @font-face  {
                    font-family: 'Cera-Pro';
                    src:url('../../../fonts/Cera-Pro-Bold.eot'); 
                    src:url('../../../fonts/Cera-Pro-Bold.eot?#') format('eot'),    
                          url('../../../fonts/Cera-Pro-Bold.woff') format('woff');
                          font-weight: 700;
                          font-style: normal;
                }
                @font-face  {
                    font-family: 'Cera-Pro';
                    src:url('../../../fonts/Cera-Pro-Black.eot'); 
                    src:url('../../../fonts/Cera-Pro-Black.eot?#') format('eot'),    
                          url('../../../fonts/Cera-Pro-Black.woff') format('woff');
                          font-weight: 900;
                          font-style: normal;
                }
            `
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: "none",
                },
                contained: t => ({
                    borderRadius: "10rem",
                    backgroundColor: t.theme.palette.secondary.main,
                    color: t.theme.palette.primary.main,
                    fontWeight: 600,
                    padding: "7px 16px",
                    "&:hover": {
                        backgroundColor: t.theme.palette.primary.main,
                        color: t.theme.palette.secondary.main,
                    },
                }),
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: t => ({
                    backgroundColor: t.theme.palette.secondary.main,
                    ".MuiTableCell-head": {
                        color: t.theme.palette.secondary.contrastText,
                        borderBottomStyle: "none",
                        fontSize: "1rem",
                    }
                })
            }
        },
        MuiTableBody: {
            styleOverrides: {
                root: t => ({
                    ".MuiTableRow-root:nth-of-type(odd)": {
                        backgroundColor: t.theme.palette.grey[50],
                    },
                })
            }
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    paddingTop: 9,
                    paddingBottom: 9,
                },
                body: t => ({
                    borderBottomColor: t.theme.palette.secondary.main,
                    color: t.theme.palette.secondary.main,
                    fontSize: "1rem",
                })
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    backgroundColor: darkPurple,
                }
            }
        }
    }
});
